import FileInput from "../common/FileInput";
import Button from "../common/Button";
import { ButtonTypes } from "../common/Button/constants";
import React, { useState } from "react";
import LoadingOverlay from "../LoadingOverlay";
import useCustomerImageFiles from "../../utils/hooks/commonly-stored/uploaded-board/customerImageFiles";
import { Formik } from "formik";
import FormikSelect from "../formik-form-components/FormikSelect";
import * as Yup from "yup";
import { UploadFileFormContainer } from "./OrderBoardStyles";

export enum UploadFileType {
  FAB_DRAWING = "fab_drawing",
  ASSEMBLY_DRAWING = "assembly_drawing",
  REFERENCE_FILE = "reference_file",
}

export const FILE_TYPE_OPTIONS = {
  reel: { value: UploadFileType.ASSEMBLY_DRAWING, label: "Assembly drawing" },
  tube: { value: UploadFileType.FAB_DRAWING, label: "Fab drawing" },
  tray: {
    value: UploadFileType.REFERENCE_FILE,
    label: "Reference images / files",
  },
};

interface UploadAdditionalFileFormValues {
  file_type: UploadFileType | null;
}

const uploadFilesSchema = Yup.object().shape({
  file_type: Yup.string().required("File type is required."),
});

export default function UploadCustomerImageFiles({
  boardId,
  closeModal,
}: {
  boardId: string;
  closeModal: () => void;
}) {
  const [files, setFiles] = useState<File[]>([]);

  const { saveCustomerImageFiles, loading } = useCustomerImageFiles();
  const submitImages = (values: UploadAdditionalFileFormValues) => {
    if (values.file_type === null) {
      return;
    }
    saveCustomerImageFiles(boardId, files, values.file_type);
    closeModal();
  };

  return (
    <>
      <LoadingOverlay loading={loading} text={"Uploading images..."} />
      <Formik
        initialValues={{
          file_type: null,
        }}
        validationSchema={uploadFilesSchema}
        onSubmit={submitImages}
      >
        {({ handleSubmit, isValid, dirty }) => {
          return (
            <UploadFileFormContainer onSubmit={handleSubmit}>
              <FormikSelect
                label={"File type"}
                name={"file_type"}
                options={Object.values(FILE_TYPE_OPTIONS).map((fileType) => ({
                  value: fileType.value,
                  label: fileType.label,
                }))}
              />
              <FileInput
                disabled={loading}
                files={files}
                setFiles={setFiles}
                isMultiple={true}
              />
              <Button
                type={ButtonTypes.SUBMIT}
                label={loading ? "Uploading Files" : "Submit"}
                disabled={loading || !isValid || files.length === 0 || !dirty}
                {...(loading || !isValid || files.length === 0 || !dirty
                  ? {
                      leftIconProps: {
                        src: "/icons/locked.svg",
                        alt: "locked",
                        iconDimension: 24,
                      },
                    }
                  : {})}
                centerText
              />
            </UploadFileFormContainer>
          );
        }}
      </Formik>
    </>
  );
}
